module.exports = __webpack_public_path__ + "img/454-d9fa39.png";